const number = {
  bind(el, {value}) {
    //必须输入为数字
    //传参为数组 [最小值，最大值，是否修改0显示为无] 限制最大最小值

    const inputel = el.querySelector('input');

    inputel.addEventListener("keyup", event => {
      inputel.value = inputel.value.replace(/[^\d.]/g, ' ');
      inputel.dispatchEvent( new CustomEvent("input", {}))
    });
    inputel.addEventListener("blur", event => {
      if (value == undefined) {
        return
      }
      if (inputel.value < value[0]) {
        inputel.value = value[0]
      }
      if (inputel.value > value[1]) {
        inputel.value = value[1]
      }

      inputel.dispatchEvent( new CustomEvent("input", {}))
// if(value[2]&&inputel.value==0){
//     inputel.value='无'
// }
    });
  }, // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    const inputel = el.querySelector('input');
    inputel.removeEventListener('blur', el.handler)
    inputel.removeEventListener('keyup', el.handler)
  },
}


export default number



// WEBPACK FOOTER //
// ./src/common/directives/number.js